import React from 'react';
import Icon from '../Icon';
import { SimulatorRoom } from '../../Types/SimulatorRoom';

interface RoomPaginationInterface {
  roomAmount: number;
  currentRoomIndex: number;
  setSelectedRoom: (room: SimulatorRoom) => void;
  simulatorRooms: any;
}

const RoomPagination = ({
  roomAmount,
  currentRoomIndex,
  setSelectedRoom,
  simulatorRooms,
}: RoomPaginationInterface) => {
  const handleActiveRoomDecrease = (): void => {
    if (currentRoomIndex >= 1) {
      setSelectedRoom(simulatorRooms[currentRoomIndex - 1]);
    } else {
      setSelectedRoom(simulatorRooms[roomAmount - 1]);
    }
  };
  const handleActiveRoomIncrease = (): void => {
    if (currentRoomIndex != roomAmount - 1) {
      setSelectedRoom(simulatorRooms[currentRoomIndex + 1]);
    } else {
      setSelectedRoom(simulatorRooms[0]);
    }
  };

  return (
    <div className="mt-2 flex flex-row items-center gap-2 rounded-full bg-white">
      <button className="p-2.5" onClick={() => handleActiveRoomDecrease()}>
        <Icon className="h-5 w-5" name="chevron-left" />
      </button>
      <div className="text-md">{`${
        currentRoomIndex + 1
      }/${roomAmount}`}</div>
      <button className="p-2.5" onClick={() => handleActiveRoomIncrease()}>
        <Icon className="h-5 w-5" name="chevron-right" />
      </button>
    </div>
  );
};

export default RoomPagination;
